import { Select } from "@chakra-ui/react";
import { useTicket } from "../hooks/tickets.hooks";
import i18n from "../i18n";
import { cn } from "../lib/utils";
import { TicketStatus } from "../types/ticket.types";

const TicketStatusBadge = ({
	id,
	editable = false,
	onChange,
}: {
	id?: number;
	editable?: boolean;
	onChange?: (status: TicketStatus) => void;
}) => {
	const ticket = useTicket(id);

	if (!ticket) {
		return null;
	}
	const status = ticket.status;
	const ticketStatusBackgroundColors = new Map<TicketStatus, string>([
		[TicketStatus.OPEN, "bg-red-50"],
		[TicketStatus.CLOSED, "bg-[#F0FDF4]"],
	]);
	const ticketStatusColors = new Map<TicketStatus, string>([
		[TicketStatus.OPEN, "text-red-700"],
		[TicketStatus.CLOSED, "text-[#15803D]"],
	]);
	const ticketStatusBorderColors = new Map<TicketStatus, string>([
		[TicketStatus.OPEN, "border-red-300!"],
		[TicketStatus.CLOSED, "border-[#BBF7D0]!"],
	]);
	const handleChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
		if (onChange) {
			onChange(evt.target.value as TicketStatus);
		}
	};

	if (!editable) {
		return (
			<div
				className={cn(
					"w-fit",
					"text-xs font-medium text-center",
					"px-2 py-0.5",
					"border! rounded-xl",
					"capitalize",
					ticketStatusBackgroundColors.get(status),
					ticketStatusColors.get(status),
					ticketStatusBorderColors.get(status),
				)}
			>
				{i18n.t(`ticket.status.${status}`)}
			</div>
		);
	}
	return (
		<Select
			h="1.5rem"
			lineHeight="1.5rem"
			rounded="xl"
			backgroundColor={ticketStatusBackgroundColors.get(status) ?? "gray.50"}
			color={ticketStatusColors.get(status) ?? "gray.700"}
			border={"solid 1px"}
			borderColor={ticketStatusBorderColors.get(status) ?? "gray.300"}
			textTransform={"capitalize"}
			w="fit-content"
			value={status}
			onChange={handleChange}
		>
			<option value="OPEN">{i18n.t("ticket.status.OPEN")}</option>
			<option value="CLOSED">{i18n.t("ticket.status.CLOSED")}</option>
		</Select>
	);
};

export default TicketStatusBadge;
